import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'

export const hasEmptyValue = (values: Array<any>, propName: string) => {
  const result = map(values, propName)
  const out = filter(result, (value) => isEmpty(value))
  return out.length > 0
}
